import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";


// page Components:
import ObjectRentals from "../../components/UI Components/ObjectList/Object/Object_rentals";

// MUI Components:
import Box  from '@mui/material/Box';
import Button from "@mui/material/Button";

// context
import { useFavorites, FavoritesDispatchContext } from "../../Context/FavoritesContext";
import { useObjList } from "../../Context/ObjectListContext";
import { useAppData } from "../../Context/AppDataContext";


function Favorites({onObjDetailPress}) {

    const navigate      = useNavigate(),
          favoritesList = useFavorites(),
          objectList    = useObjList(),
          AppData       = useAppData();

    const [selObjects,setSelObjects] = useState([]);



     console.log(AppData, "AppData");

    useEffect(() => {

        let oObject, aObjects = []; 

     favoritesList.forEach( (oItem) => {
            oObject  = undefined;
            oObject = objectList['data'].find(obj => obj._id === oItem.objID);
            

            if(oObject) {
                aObjects = [...aObjects, oObject];
                // aObjects.push(oObject);
            }        
        });
        
        setSelObjects(aObjects);

    },[favoritesList, objectList])

    return(
        <Box>
            {/* <Box sx={{display:'flex', flexDirection:'column', width:'100%'}}> */}
                {/* <Button sx={{width:'5rem', alignSelf:'end'}} onClick={()=> navigate(-1)}>Back</Button> */}
            
                <Box>
                    {
                        selObjects.map( (oItem, index) => {
                            return(
                                <Box sx={{ maxWidth:{md:'45%',lg:'45%',xl:'45%'} }}>
                                    <ObjectRentals 
                                        key={index}
                                        oObject={oItem}
                                        onObjDetailPress={onObjDetailPress}>
                                    </ObjectRentals>
                                </Box>
                            )

                        })
                    }
                </Box>

            {/* </Box> */}
        </Box>

    )
}

export default Favorites;